import ModalComponent from "@/components/ui/modal";
import { Text, Flex } from "@chakra-ui/react";
import { useI18n } from "@/hooks/useI18n";
import { useMedia } from "@/hooks/useMedia";
import { BXButton } from "@/styles";

const DelApiKeyModal = ({ show, onOK, onCancel, delInfo }) => {
  const { t } = useI18n();
  const { isMobile } = useMedia();

  return (
    <ModalComponent
      isShow={show}
      style={{ width: !isMobile ? "400px" : "calc(100% - 30px)" }}
    >
      <Flex
        flexDirection={"column"}
        justifyContent={"center"}
        p={["50px 20px"]}
      >
        <Text mt={"20px"} fontWeight={600} fontSize={"16px"}>
          {t("您确认要删除此API Key吗?")}
        </Text>
        <Text color={"#010313"} mt={"20px"}>
          {t(
            "evXPcpwd2FpVPi7jqZDTk8pcUtdwKWspSRaDkoUAUZTLaL3qL3ozMIG0QBR2ASXB"
          )}
        </Text>
        <Flex justifyContent={"center"} mt={"30px"} w={"100%"}>
          <BXButton
            className="cancel"
            mr="10px"
            onClick={() => {
              onCancel && onCancel();
            }}
          >
            {t("UNForxvjDLCZdGrmWkX")}
          </BXButton>
          <BXButton
            w={["100%", "200px"]}
            onClick={() => {
              onOK && onOK();
            }}
          >
            {t("AQrCocFqoKoYieUnT")}
          </BXButton>
        </Flex>
      </Flex>
    </ModalComponent>
  );
};

export default DelApiKeyModal;
